import { AdState } from 'common/advertising/ad-state'
import { TogglesState } from 'common/feature-togglings/reducer'
import { VideoOptions } from 'component-library/content/Video/PlayerInterface'
import { getInlinePositionedAds } from './lib/get-inline-positioned-ads'
import { getInlinePositionedOovvuuContent } from './lib/get-inline-positioned-oovvuu'
import { getInlinePositionedPointer } from './lib/get-inline-positioned-pointer'
import { isFeatureEnabled } from 'common/feature-togglings/features'
import { Logger } from 'typescript-log'
import { PublicationTypes, MetaTypes } from './render-publication'
import { AllEvents } from 'common/events/all-events'

export const getInlinePositionedContent = (props: {
    adState: AdState
    publication: PublicationTypes
    meta: MetaTypes
    log: Logger
    toggles: TogglesState
    onEvent: (event: AllEvents) => void
}) => {
    if (!props.publication) {
        return []
    }

    // inline content should not be rendered on gallery publications
    if (
        props.publication.kind === 'gallery' ||
        props.meta.kind === 'gallery' ||
        !props.meta.inlinePublicationContent
    ) {
        return []
    }

    const videoOptions: VideoOptions = {
        adUnitPath: props.adState.targeting.adUnitPath,
        canAutoplayVideos: isFeatureEnabled(props.toggles, 'can-autoplay-video'),
        enableNielsenVideoReporting: isFeatureEnabled(
            props.toggles,
            'nielsen-video-events-inline-videos'
        ),
        enableSnowplow: isFeatureEnabled(props.toggles, 'snowplow'),
        enablePrebid: isFeatureEnabled(props.toggles, 'prebid-video'),
    }

    return [
        ...getInlinePositionedAds({
            adState: props.adState,
            publication: props.publication,
            inlinePublicationContent: props.meta.inlinePublicationContent,
            onEvent: props.onEvent,
        }),
        ...getInlinePositionedOovvuuContent({
            log: props.log,
            onEvent: props.onEvent,
            videoOptions,
            publication: props.publication,
            inlinePublicationContent: props.meta.inlinePublicationContent,
            toggles: props.toggles,
        }),
        ...getInlinePositionedPointer({
            publication: props.publication,
            inlinePublicationContent: props.meta.inlinePublicationContent,
        }),
    ]
}
